export default __webpack_public_path__ + "media/images/front/footer/note_logo-fb2207386a5ceab23c1daa8488cb1d15.svg";